// downloadHandler.ts
//import "./../global"
export function downloadHandler(languageSelected: boolean): void {
    document.addEventListener("click", (e: MouseEvent) => {
        if (
            (e.target as HTMLElement).classList.contains(
                "file-download-dropdown",
            )
        ) {
            let languageSelector = (
                e.target as HTMLElement
            ).parentElement?.querySelector(
                ".c-downloads__language-wrap",
            ) as HTMLElement | null

            if (languageSelector && languageSelected === false) {
                languageSelector.style.display = "block"
                e.preventDefault()
            }
        }
    })

    document.addEventListener("mouseup", (e: MouseEvent) => {
        if (!e.target) return

        let targetElement = e.target as HTMLElement
        let closestLanguageWrap = targetElement.closest(
            ".c-downloads__language-wrap",
        )

        if (!closestLanguageWrap) {
            let languageWraps = document.querySelectorAll(
                ".c-downloads__language-wrap",
            )
            languageWraps.forEach((languageWrap) => {
                let langwarp = languageWrap as HTMLElement
                langwarp.style.display = "none"
            })
        }
    })
}
